import {
  SmartFileInput,
  SmartFileInputProps,
} from 'app/components/shared/FormComponents/SmartFileInput'
import { Button } from 'app/components/ui/Button'
import { Label } from 'app/components/ui/Label'
import { Text } from 'app/components/ui/Text'
import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import styled from 'styled-components'

type Props = {
  previewUrl?: string
} & SmartFileInputProps

export const SmartFileInputPreview = ({
  previewUrl,
  children,
  ...inputProps
}: WithChildren<Props>): JSX.Element => {
  const { getValues } = useFormContext()

  const initialValue = getValues(inputProps.name)

  // Preview is visible only if the previwew url is passed and if a values is not set on the form field
  const [isPreviewVisible, setIsPreviewVisible] = useState<boolean>(
    !initialValue && !!previewUrl
  )

  return !isPreviewVisible ? (
    <SmartFileInput {...inputProps}>{children}</SmartFileInput>
  ) : (
    <PreviewWrapper>
      {inputProps.label && (
        <Label color={inputProps.labelColor}>
          {inputProps.label}
          {inputProps.labelRequired ? <RequiredSpan> * </RequiredSpan> : null}
        </Label>
      )}
      <PreviewDocumentWrapper>
        <Text variant='s18' mb={1}>
          <a href={previewUrl} rel='noreferrer' target='_blank'>
            Apri il documento caricato
          </a>
        </Text>
        <Button variant={'cyan'} onClick={() => setIsPreviewVisible(false)}>
          Sostituisci
        </Button>
      </PreviewDocumentWrapper>
    </PreviewWrapper>
  )
}

const PreviewWrapper = styled.div``

const RequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.secondari.arancioneScuro};
`

const PreviewDocumentWrapper = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  column-gap: 2rem;
  row-gap: 1rem;
`
